var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.433 6.173a.5.5 0 01.8.6l-1.5 2.346a.5.5 0 01-.8 0l-1.5-2.344a.5.5 0 11.8-.601l.555.875a5.308 5.308 0 012.43-3.603 5.311 5.311 0 016.61.863.472.472 0 01-.016.666.468.468 0 01-.663-.017 4.37 4.37 0 00-5.44-.71 4.365 4.365 0 00-2.02 3.101l.744-1.176zm8.634.67l1.5 2.342a.5.5 0 11-.8.601l-.544-.858a5.337 5.337 0 01-2.445 3.62c-.86.528-1.823.785-2.782.785a5.32 5.32 0 01-3.898-1.689.504.504 0 01.024-.71.499.499 0 01.706.025 4.333 4.333 0 005.427.733A4.338 4.338 0 0012.25 8.71l-.682 1.078a.5.5 0 11-.8-.601l1.5-2.345a.5.5 0 01.8 0z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/iconRefresh.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };